import { render } from "./ComponenteConfiguracion.vue?vue&type=template&id=3b11bd62"
import script from "./ComponenteConfiguracion.vue?vue&type=script&lang=js"
export * from "./ComponenteConfiguracion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__